import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { LayoutContainer, Row } from 'gumdrops';

import { ADVERTISING_AUTH_APP } from '../../api/constants';

const containerStyle = { paddingTop: '100px' };
const logoStyle = { height: '60px', margin: 'auto', display: 'block' };

/**
 * Shown when this tab has already been through SSO once and come back without a usable
 * token, which usually means the account has no access to Publisher Center or the
 * session at advertising-apps-auth is also stale.
 *
 * Deliberately static, not an auto-redirect: bouncing straight back into redirectToAuth()
 * would recreate the very loop this screen exists to break, and the user would never get
 * a chance to read what happened or press Back. There is a manual link instead so the
 * user chooses to try again.
 */
const AuthRequired = () => (
    <LayoutContainer style={containerStyle}>
        <Row style={{ padding: '0.50rem' }}>
            <img src="/assets/logo.svg" style={logoStyle} />
        </Row>
        <Row className="gds-text--header-sm -text-center -m-t-5">
            Your session has ended, or your account does not have access to Publisher Center.
            <br />
            <br />
            <a href={ADVERTISING_AUTH_APP}>Return to the applications list</a>
        </Row>
    </LayoutContainer>
);

export default AuthRequired;
